import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { initDB } from 'react-indexed-db';
import { dbConfig } from './functions/dbConfig';
import { ConfigProvider } from 'antd';
import { PRIMARY_COLOR } from './common/ThemeConstants';
import { useEffect } from 'react';
import { message } from "antd";



import 'antd/dist/antd.variable.min.css';
import './App.css';

ConfigProvider.config({
  theme: {
    primaryColor: PRIMARY_COLOR, // "#4561B9",
  },
});

initDB(dbConfig);






const App = () => {

// if ('serviceWorker' in navigator) {
//   navigator.serviceWorker.register('/sw.js')
//     .then(() => console.log("Service Worker Registered"))
//     .catch(err => console.log("SW registration failed:", err));
// }

// Add this ONCE at app initialization
message.config({
  top: 100,
  duration: 3,
  maxCount: 3,
  zIndex: 99999, // Higher than all modals
});


  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;
